import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Row, Table, Typography, Modal } from "antd";
import productstyle from "./productlist/style";
import filter from "../../../src/assets/Images/filter.png";
import StyledProductWrapper from "./style";
import styled from "styled-components";
import { ReactComponent as Edit } from "../../../src/assets/Icons/Edit.svg";
import { ReactComponent as Delete } from "../../../src/assets/Icons/Delete.svg";
import { ReactComponent as Tick } from "../../../src/assets/Icons/Tick.svg";

const { Title } = Typography;

const StyledTable = styled(Table)``;

const ProductList = () => {
  // const [loading, setLoading] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [searchFilter, setSearchFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const columns = [
    {
      title: "Product ID",
      dataIndex: "product_id",
      key: "product_id",
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Product Name",
      dataIndex: "product_name",
      key: "product_name",
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Approval Status",
      dataIndex: "approval_status",
      key: "approval_status",
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Action",
      key: "action",
      width: "12%",
      render: (record) => {
        return (
          <>
            <div className="table_action_icons">
              <>
                <Edit
                  className="actionicon_style"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClickEdit(record);
                  }}
                />
                <Delete
                  className="actionicon_style"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete(record);
                  }}
                />
              </>
            </div>
          </>
        );
      },
    },
  ];

  const getFilteredClient = [
    {
      product_id: "001",
      product_name: "Abcd1",
      plan: "abcd1@gmail.com",
      description: "aaa",
      status: "Active",
      approval_status: "Pending",
    },
    {
      product_id: "002",
      product_name: "Abcd2",
      plan: "abcd2@gmail.com",
      description: "bbb",
      status: "Active",
      approval_status: "Pending",
    },
    {
      product_id: "003",
      product_name: "Abcd3",
      plan: "abcd3@gmail.com",
      description: "ccc",
      status: "Active",
      approval_status: "Pending",
    },
    {
      product_id: "004",
      product_name: "Abcd4",
      plan: "abcd4@gmail.com",
      description: "ddd",
      status: "Active",
      approval_status: "Pending",
    },
  ];

  const navigate = useNavigate();

  useEffect(() => {
    setFilteredData(getFilteredClient);
  }, []);

  const handleSearchFilter = (searchValue) => {
    setSearchFilter(searchValue);

    if (searchValue.trim() === "") {
      setFilteredData(getFilteredClient);
    } else {
      const filtered = getFilteredClient.filter((product) =>
        product.product_name.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };

  const handleClickNav = () => {
    navigate("/productlist/addproductlist", { replace: true });
  };

  const handleClickEdit = (record) => {
    navigate("/productlist/editproductlist", {
      state: {
        isEdit: true,
        editData: record,
      },
      replace: true,
    });
  };

  const handleDelete = (record) => {
    setSelectedRecord(record);
    setDeleteModalVisible(true);
  };

  const handleDeleteConfirm = () => {
    console.log("Deleting product:", selectedRecord);

    setDeleteModalVisible(false);
    setSelectedRecord(null);
    setSuccessModalVisible(true);
  };

  useEffect(() => {
    if (successModalVisible) {
      setTimeout(() => {
        setSuccessModalVisible(false);
      }, 2000);
    }
  }, [successModalVisible]);

  const handleDeleteCancel = () => {
    setDeleteModalVisible(false);
    setSelectedRecord(null);
  };

  return (
    <>
      <StyledProductWrapper>
        <div>
          <Title level={3}> Product List</Title>
        </div>
        <Row gutter={16}>
          <Col sm={24} md={12} lg={12}>
            <div>
              <div style={productstyle.totalno}>
                <div>
                  <Title className="product_total_count" level={3}>
                    Total: {filteredData.length}{" "}
                  </Title>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={12}>
            <Row className="" gutter={12}>
              <Col sm={24} md={4} lg={16}>
                <div className="product_filter_action_conatiner">
                  <div style={productstyle.filterstyle}>
                    <img
                      src={filter}
                      alt="filter"
                      style={productstyle.imagestyle}
                    />
                    <input
                      type="text"
                      placeholder="Product Name"
                      style={productstyle.inputstyle}
                      value={searchFilter}
                      onChange={(e) => handleSearchFilter(e.target.value)}
                    />
                  </div>
                </div>
              </Col>
              <Col sm={24} md={4} lg={8}>
                <div className="add_productlist_button">
                  <Button
                    onClick={handleClickNav}
                    style={productstyle.meadd}
                    type="primary"
                  >
                    Add Product List{" "}
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <br />
        <div style={productstyle.table}>
          <StyledTable
            dataSource={filteredData}
            columns={columns}
            rowClassName={(record, index) =>
              index % 2 === 0 ? "" : "non-white"
            }
            rowKey="checkin_id"
            id="Table"
            showSorterTooltip={{
              target: "sorter-icon",
            }}
          />
        </div>
      </StyledProductWrapper>

      <Modal
        open={deleteModalVisible}
        footer={false}
        onCancel={handleDeleteCancel}
      >
        <StyledProductWrapper>
          <p>Are you sure you want to delete this Product List?</p>
          <div className="delete_modal_footer">
            <Button
              className="cancel_button_style"
              onClick={handleDeleteCancel}
            >
              Cancel
            </Button>
            <Button onClick={handleDeleteConfirm} className="logout-button">
              Delete
            </Button>
          </div>
        </StyledProductWrapper>
      </Modal>

      <Modal
        open={successModalVisible}
        footer={false}
        closable={false}
        centered
        width={300}
      >
        <StyledProductWrapper>
          <div style={{ textAlign: "center" }}>
            <p
              style={{
                fontSize: "18px",
                marginBottom: "20px",
              }}
            >
              <Tick style={{ width: "50px", height: "50px" }} />
              <br />
              Deleted
            </p>
          </div>
        </StyledProductWrapper>
      </Modal>
    </>
  );
};

export default ProductList;
